import { ReactNode } from 'react';
import { useReduxState } from 'hooks';
import { AdminPage } from 'components/admin';
import { PageInnerContent, PageSidebar } from 'components/page';

interface Props {
  activeLink: string;
  children: ReactNode;
}

const AdminAdminsPage = ({ activeLink, children }: Props) => {
  const { messages } = useReduxState();

  return (
    <AdminPage activeLink="/admin/admins" withSidebar={true}>
      <PageSidebar
        active={`/admin${activeLink}`}
        links={[
          {
            href: '/admin/admins',
            icon: 'user',
            title: messages.usersAdmins
          },
          {
            href: '/admin/admin-groups',
            icon: 'users',
            title: messages.adminGroups
          },
          {
            href: '/admin/supervisors',
            icon: 'sitemap',
            title: messages.adminSupervisors
          },
          {
            href: '/admin/admin-events',
            icon: 'list',
            title: messages.commonActivityLog
          }
        ]}
      />

      <PageInnerContent>{children}</PageInnerContent>
    </AdminPage>
  );
};

export default AdminAdminsPage;
